interface ISortByTypes {
  recommended: string;
  lowestPrice: string;
  highestPrice: string;
}

export const SortByTypes: ISortByTypes = {
  recommended: "recommended",
  lowestPrice: "lowest_price",
  highestPrice: "highest_price",
};
